import { useQuery } from '@tanstack/react-query';

import { DynamicPricingSurchargeEstimateParams, DynamicPricingSurchargeEstimates } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { dynamicPricingSurchargeEstimatesQueryKeys } from './dynamicPricingSurchargeEstimatesQueryKeys';

interface UseGetDynamicPricingSurchargeEstimatesOptions {
  enabled?: boolean;
  requestVersion?: number;
}

export function useGetDynamicPricingSurchargeEstimates(
  params: DynamicPricingSurchargeEstimateParams | undefined,
  options: UseGetDynamicPricingSurchargeEstimatesOptions = {},
) {
  const { enabled = true, requestVersion } = options;

  return useQuery<DynamicPricingSurchargeEstimates>({
    queryKey: dynamicPricingSurchargeEstimatesQueryKeys.detail(params, requestVersion),
    queryFn: async ({ signal }) => {
      if (!params) {
        throw new Error('Surcharge estimate parameters are required.');
      }

      return await LereService.getDynamicPricingSurchargeEstimates(params, { signal });
    },
    enabled: enabled && !!params,
    retry: false,
  });
}
